import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { BcfIssueItem } from "@ServerTypes/issues/issues.schema";

/** BCF file buffer data (S3 response body structure, client-side only) */
export interface BcfBufferData {
  Body?: {
    data?: number[];
    type?: string;
  };
  ContentType?: string;
  ContentLength?: number;
  ETag?: string;
}

interface BcfState {
  currentBcfId: string;
  bcfData: BcfBufferData | null;
  isAutoBcfLoaded: boolean;
}

const initialBcfState: BcfState = {
  currentBcfId: "",
  bcfData: null,
  isAutoBcfLoaded: false,
};

const itemsHaveErrorSlice = createSlice({
  name: "itemsHaveError",
  initialState: false,
  reducers: {
    setItemsHaveError: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const itemsAreLoadingSlice = createSlice({
  name: "itemsAreLoading",
  initialState: false,
  reducers: {
    setItemsAreLoading: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const itemsSlice = createSlice({
  name: "items",
  initialState: [] as BcfIssueItem[],
  reducers: {
    setItems: (_state: BcfIssueItem[], action: PayloadAction<BcfIssueItem[]>) => action.payload,
  },
});

const bcfDataSlice = createSlice({
  name: "bcfData",
  initialState: initialBcfState,
  reducers: {
    saveBcfData: (state: BcfState, action: PayloadAction<string>) => {
      if (action.payload) {
        state.currentBcfId = action.payload;
      }
    },
    setBcfBufferData: (state: BcfState, action: PayloadAction<BcfBufferData | null>) => {
      if (action.payload) {
        state.bcfData = action.payload;
      }
    },
    setAutoBcfLoaded: (state: BcfState, action: PayloadAction<boolean>) => {
      if (action.payload !== undefined) {
        state.isAutoBcfLoaded = action.payload;
      }
    },
  },
});

export const { setItemsHaveError } = itemsHaveErrorSlice.actions;
export const { setItemsAreLoading } = itemsAreLoadingSlice.actions;
export const { setItems } = itemsSlice.actions;
export const { saveBcfData, setBcfBufferData, setAutoBcfLoaded } = bcfDataSlice.actions;

export const itemsHaveError = itemsHaveErrorSlice.reducer;
export const itemsAreLoading = itemsAreLoadingSlice.reducer;
export const items = itemsSlice.reducer;
export const bcfData = bcfDataSlice.reducer;
